import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { IProofComponent } from './i-proof.component';

const routes: Routes = [{ path: '', component: IProofComponent }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class IProofRoutingModule { }
